import { filter, map, tap } from 'rxjs/operators';
var AuthGuardAuthenticadeOnly = /** @class */ (function () {
    function AuthGuardAuthenticadeOnly(authService) {
        var _this = this;
        this.authService = authService;
        this.authService.isAuthenticated$.subscribe(function (i) { return _this.isAuthenticated = i; });
    }
    AuthGuardAuthenticadeOnly.prototype.canActivate = function (route, state) {
        var _this = this;
        return this.authService.isDoneLoading$
            .pipe(filter(function (isDone) { return isDone; }))
            .pipe(tap(function (_) { return _this.isAuthenticated || _this.authService.login(state.url); }))
            .pipe(map(function (_) { return _this.isAuthenticated; }));
    };
    return AuthGuardAuthenticadeOnly;
}());
export { AuthGuardAuthenticadeOnly };
